<script>
    import Vue from "vue";

    export default {
        name: "Footer",
    };
</script>

<template>
    <footer>
        <slot />
        <div class="footer-contents">
            <div>
                Code &amp; design all in-house
            </div>
            <div>
                <a href="https://tomstriker.org/">
                    tomstriker.org
                </a>
                |
                <a href="mailto:tom.striker.b@gmail.com">
                    Contact
                </a>
            </div>
        </div>
    </footer>
</template>


<style lang="scss">
    footer {
        font-size: 14px;
        padding: 50px 0;
        font-weight: 300;
        color: #2e2e2e;

        .footer-contents {
            max-width: $max-width;
            padding: 0 $horiz-padding;
            justify-content: space-between;
            margin: 0 auto;
            display: flex;
        }

        a {
            font-weight: 400;
        }

        @media (max-width: $mobile-break) {
            padding: 25px 0;
            .footer-contents {
                padding: 0 30px;
            }
        }

        @media (max-width: 500px) {
            .footer-contents {
                display: grid;
                grid-template-columns: 1fr;
                gap: 5px;
                margin-top: 2em;

                & > div,
                & > div:last-child {
                    text-align: center;
                }
            }
        }
    }
</style>

